import FormularioResponderExterno from './FormularioResponderExterno';

export default FormularioResponderExterno;